import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, ArrowRight, Plus } from "lucide-react";
import { api } from "@/lib/api";

export const ArticlesQuickCard = () => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/admin/articles").then((r) => setItems(Array.isArray(r.data) ? r.data : [])).catch(() => setItems([]));
  }, []);
  const pub = (items || []).filter((a) => a.published).length;
  const draft = (items || []).length - pub;
  return (
    <section data-testid="admin-articles-quick" className="mt-4 flex flex-col gap-4 rounded-3xl bg-surface p-6 ring-1 ring-white/[0.07] sm:flex-row sm:items-center sm:justify-between md:p-8">
      <div className="flex items-center gap-4">
        <FileText className="h-8 w-8 shrink-0 text-volt" />
        <div>
          <p className="font-display text-xl text-paper">Artikel blog</p>
          <p className="text-sm text-zinc-400" data-testid="admin-articles-quick-stats">{items ? `${pub} terbit · ${draft} draft` : "Memuat…"}</p>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <Link to="/tigasatu/artikel/baru" data-testid="admin-articles-quick-new" className="flex items-center gap-1.5 rounded-full bg-volt px-4 py-2 text-sm font-semibold text-ink"><Plus className="h-4 w-4" /> Tulis artikel</Link>
        <Link to="/tigasatu/artikel" data-testid="admin-articles-quick-link" className="flex items-center gap-1.5 rounded-full border border-white/15 px-4 py-2 text-sm text-zinc-200 hover:border-volt">Kelola artikel <ArrowRight className="h-4 w-4" /></Link>
      </div>
    </section>
  );
};
